import React, { useState, useEffect } from 'react';

function FacebookUrlEditor({ isOpen, onClose, initialUrl, onSave }) {
  const [url, setUrl] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState('');

  // Initialize with the current URL when opened
  useEffect(() => {
    if (isOpen && initialUrl) {
      setUrl(initialUrl);
    }
  }, [isOpen, initialUrl]);

  const validateUrl = (input) => {
    // Basic URL validation - checks if it has facebook.com in it
    return input.includes('facebook.com');
  };

  const handleSave = async () => {
    // Validate URL before saving
    if (!validateUrl(url)) {
      setError('Prosím zadajte platný Facebook URL');
      return;
    }

    setError('');
    setIsSaving(true);
    
    try {
      await onSave(url);
      onClose();
    } catch (error) {
      console.error('Error saving Facebook URL:', error);
      setError('Nepodarilo sa uložiť URL. Prosím skúste znova.');
    } finally {
      setIsSaving(false);
    }
  };

  // Don't render anything if not open
  if (!isOpen) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={styles.header}>
          <h2 style={styles.title}>Nastaviť Facebook URL</h2>
          <button 
            style={styles.closeButton} 
            onClick={onClose}
            title="Zavrieť"
          >
            ✕
          </button>
        </div>
        
        <div style={styles.content}>
          <p style={styles.description}>
            Zadajte Facebook URL, ktorý sa použije v navigačnej lište:
          </p>
          
          <input
            type="url"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="https://www.facebook.com/vasa-stranka"
            style={styles.input}
          />
          
          {error && (
            <p style={styles.errorMessage}>{error}</p>
          )}
        </div>
        
        <div style={styles.actions}>
          <button 
            style={styles.cancelButton} 
            onClick={onClose}
            disabled={isSaving}
          >
            Zrušiť
          </button>
          <button 
            style={styles.saveButton} 
            onClick={handleSave}
            disabled={isSaving}
          >
            {isSaving ? 'Ukladá sa...' : 'Uložiť URL'}
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modal: {
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
    width: '90%',
    maxWidth: '500px',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  header: {
    padding: '15px 20px',
    borderBottom: '1px solid #eee',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    margin: 0,
    fontSize: '1.4rem',
    color: '#333',
  },
  closeButton: {
    background: 'none',
    border: 'none',
    fontSize: '1.5rem',
    cursor: 'pointer',
    color: '#999',
  },
  content: {
    padding: '20px',
  },
  description: {
    margin: '0 0 15px 0',
    color: '#555',
  },
  input: {
    width: '100%',
    padding: '10px',
    fontSize: '16px',
    borderRadius: '4px',
    border: '1px solid #ddd',
    boxSizing: 'border-box',
  },
  errorMessage: {
    color: '#d83a3a',
    margin: '10px 0 0 0',
    fontSize: '14px',
  },
  actions: {
    padding: '15px 20px',
    borderTop: '1px solid #eee',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
  },
  saveButton: {
    padding: '8px 16px',
    backgroundColor: '#2c69a0',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 'bold',
  },
  cancelButton: {
    padding: '8px 16px',
    backgroundColor: '#f5f5f5',
    color: '#333',
    border: '1px solid #ddd',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
  }
};

export default FacebookUrlEditor; 